<style lang="scss" scoped>
.video-section {
    width: 100%;
    margin-bottom: -16px;

    img {
        object-fit: fill;
        object-position: center;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    ::v-deep #silentbox-gallery {
        margin: 0 -8px;
        display: flex;
        flex-wrap: wrap;
    }

    ::v-deep #silentbox-overlay {
        iframe {
            width: 960px;
            height: 540px;
        }
    }

    ::v-deep .silentbox-item {
        width: 50%;
        padding: 0 8px;
        margin-bottom: 16px;

        @media screen and (min-width: 768px) {
            width: 33.333333%;
        }

        .thumbnail {
            padding-top: 75%;
            position: relative;
            border: 1px solid #ececec;
            background-color: #ececec;
            border-radius: 4px;
            cursor: pointer;
            overflow: hidden;
        }

        .play-button {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            width: 40px;
            height: 40px;
            background-color: #fff;
            border-radius: 50%;
            display: inline-flex;
            justify-content: center;
            align-items: center;

            svg {
                fill: #23b32f;
                width: 8px;
                height: 11px;
            }

            @media screen and (min-width: 1024px) {
                width: 80px;
                height: 80px;

                svg {
                    width: 18px;
                    height: 22px;
                }
            }
        }
    }

    &.single {
        ::v-deep .silentbox-item {
            width: 100%;

            &:nth-child(n + 2) {
                display: none;
            }

            .play-button {
                width: 80px !important;
                height: 80px !important;

                svg {
                    width: 18px !important;
                    height: 22px !important;
                }
            }
        }
    }
}
</style>

<template>
    <div class="video-section" :class="{single: single}">
        <silent-box :gallery="formattedMedia" :autoplay="true">
            <template v-slot:silentbox-item="{ silentboxItem }">
                <div class="thumbnail">
                    <img v-if="silentboxItem.type === 'image'" class="lazyload" :data-src="silentboxItem.src" :alt="silentboxItem.alt">
                    <img v-if="silentboxItem.type === 'video'" class="lazyload" :data-src="silentboxItem.thumbnail" :alt="silentboxItem.alt">
                    <div v-if="silentboxItem.type === 'video'" class="play-button" v-html="svg('play')"></div>
                </div>
            </template>
        </silent-box>
    </div>
</template>

<script>
export default {
    name: "Ui.VideoSection",

    props: {
        media: {
            type: Array,
            required: true
        },

        single: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        formattedMedia() {
            return this.media.map(m => ({
                type: m.type.indexOf('video') >= 0 ? 'video' : 'image',
                src: m.path,
                //alt: 'test'
            }))
        }
    }
}
</script>